<template>
  <div class="product-block-shop">
    <div class="product-block" :style="getProductBlockStyles">
      <div class="product-block-title" @click.stop="showModal" :style="getProductTitleStyles">
        <em  :style="getProductCameraStyles" class="fas fa-info-circle camera" v-if="hasMoreInfo && showPopupIcon"></em>
        <span :style="getProductNameStyles">{{ myCommercialName.getText(selectedLanguage) }}</span>
        <template v-if="showProductTagBlock">
          <template v-for="(tag, index) in myTags">
            <img v-if="productTagsIcon"
                 :src="tag.image"
                 class="features-img"
                 :alt="productTagTranslate(tag)"
                 :style="{ display: 'inline-block', verticalAlign: 'top' }"
                 :key="`img-${tag.guid}`"/>

            <span v-else
                  :style="{ ...tag.tagTitleProps.getStyles(), display: 'inline-block',
                   verticalAlign: 'top' }"
                  :key="`span-${tag.guid}`">
              {{ tag.abbreviation.getTextOrEmpty(selectedLanguage) }}{{ (myTags.length - 1) !== index ? ',' : '' }}
            </span>
          </template>
        </template>
        <span :style="myProductProps.pricesTextProps.getStyles()" class="prices-to-right">{{ productPrices }}</span>
        <em v-if="mergedProps.special" :style="myProductProps.specialProductsProps.getStyles()" class="fas fa-star"></em>
        <span v-if="mergedProps.special"
              :style="myProductProps.specialDescriptionTextProps.getStyles()">
          <u>{{ mySpecialDescription.getText(selectedLanguage) }}</u>
        </span>
      </div>
      <div class="product-block-description" :style="getProductDescriptionStyles">
        <span :style="myProductProps.commercialDescriptionTextProps.getStyles()">
          {{ myCommercialDescription.getTextOrEmpty(selectedLanguage) }}
        </span>
      </div>
      <div v-if="showFeaturesBlock" class="features">
        <div v-for="(feature, index) in myFeatures" :key="feature.guid">
            <img class="features-img" v-if="featuresIcon" :src="feature.image" :alt="featureTranslate(feature)"/>
            <span v-else :style="feature.featureTitleProps.getStyles()">
              {{ feature.legendName.getText(selectedLanguage) }}{{(myFeatures.length - 1) !== index ? ',' : ''}}
            </span>
        </div>
      </div>
      <div class="product-block-recommendation-text" v-if="hasProductRecommendations" @click="showRecommendationModal">
        <span :style="recommendationTextStyles">
          {{ recommendationText }}
        </span>
      </div>
      <product-popup-block v-model="isModalVisible" @close="closeModal" :title="effectiveCommercialName"
                    :description="effectiveCommercialDescription" :image="image"
                    :productProps="productProps" :productPrices="productPrices" @submit="submitProduct"
                    :textProductPopupQty="shopTextProductPopupQty"
                    :textProductPopupComment="shopTextProductPopupComment"
                    :textProductPopupSpecialTextComment="shopTextProductPopupSpecialTextComment"
                    :textProductPopupAddBtn="shopTextProductPopupAddBtn"
                    :shopTextBtnProps="shopTextBtnProps"
      />
      <recommendation-popup-block v-show="isRecommendationModalVisible" v-if="hasProductRecommendations"
                                  @close="closeRecommendationModal"
                                  :product-recommendations="productRecommendations"/>
    </div>
    <v-btn
      icon
      x-small
      @click.stop="showModal"
    >
      <v-icon
        color="black"
        small
      >
        fas fa-plus
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { TagsItem } from '../models/TagsItem';
import RecommendationPopupBlock from './RecommendationPopupBlock.vue';
import Block from './Block.vue';
import ProductPopupBlock from './ProductPopupBlock.vue';
import { ProductProps } from '../models/styleModels/ProductProps';
import {
  BlockProps, FeaturesItem, MultiLanguageText, SaleFormat, TextProps
} from '../models';

export default {
  name: 'product-shop-block',
  components: { RecommendationPopupBlock, ProductPopupBlock },
  extends: Block,
  props: {
    commercialName: { type: Object, required: true, default: () => null },
    commercialDescription: { type: Object, default: () => null },
    longCommercialDescription: { type: Object, default: () => null },
    shopTextProductPopupQty: { type: Object, required: true, default: () => null },
    shopTextProductPopupComment: { type: Object, required: true, default: () => null },
    shopTextProductPopupSpecialTextComment: { type: Object, required: true, default: () => null },
    shopTextProductPopupAddBtn: { type: Object, required: true, default: () => null },
    shopTextBtnProps: { type: Object, required: true, default: () => ({}) },
    saleWeightIndex: { type: Number },
    image: { type: String },
    productGuid: { type: String, required: true },
    menuProductGuid: { type: String, required: true },
    special: { type: Boolean, required: true },
    popupIcon: { type: Boolean, require: true },
    specialDescription: { type: Object, default: () => null },
    specialFrame: { type: Boolean, required: true },
    saleFormats: { type: Array, required: true },
    features: { type: Array },
    tags: { type: Array },
    outOfStock: { type: Boolean, default: false },
    productProps: {
      type: Object,
      required: true,
      default: () => {
      }
    },
    productTitleProps: {
      type: Object,
      required: true,
      default: () => {
      }
    },
    productDescriptionProps: {
      type: Object,
      required: true,
      default: () => {
      }
    },
    productRecommendations: {
      type: Array,
      required: false,
      default: () => []
    },
    extraProps: {
      type: Object,
      require: false,
      default: () => {}
    }
  },
  data() {
    return {
      isModalVisible: false,
      isRecommendationModalVisible: false,
    };
  },
  methods: {
    ...mapActions(['addShopList']),
    showModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    submitProduct({ totalPrice, qty, comments, unitPrice }) {
      const key = `${this.menuProductGuid}-${unitPrice}`;
      this.addShopList({
        key,
        productGuid: this.productGuid,
        menuProductGuid: this.menuProductGuid,
        productTotalPrice: totalPrice,
        productUnitPrice: unitPrice,
        qty,
        image: this.image,
        comments,
        commercialName: this.effectiveCommercialName
      });
      this.closeModal();
    },
    showRecommendationModal() {
      if (this.hasProductRecommendations) {
        this.isRecommendationModalVisible = true;
      }
    },
    closeRecommendationModal() {
      this.isRecommendationModalVisible = false;
    },
    featureTranslate(feature) {
      return (feature !== undefined) ? feature.legendName.getText(this.selectedLanguage) : '';
    },
    productTagTranslate(tag) {
      return (tag !== undefined) ? tag.name.getText(this.selectedLanguage) : '';
    },
  },
  computed: {
    ...mapGetters(['userDefinedData', 'getProductPrice', 'currencySymbol', 'currencyPosition', 'showFeatures', 'showIconFeatures', 'showProductTags', 'showIconProductTags']),
    mergedProps() {
      const userDefinedData = this.userDefinedData[this.menuProductGuid] || {};
      return { ...this.$props, ...userDefinedData, ...this.extraProps };
    },
    mySaleFormats() {
      return this.saleFormats.map((_) => new SaleFormat(_));
    },
    effectiveCommercialName() {
      return this.mergedProps.commercialName;
    },
    effectiveCommercialDescription() {
      return this.mergedProps.commercialDescription;
    },
    myCommercialName() {
      return new MultiLanguageText(this.effectiveCommercialName);
    },
    myCommercialDescription() {
      return new MultiLanguageText(this.effectiveCommercialDescription);
    },
    mySpecialDescription() {
      return new MultiLanguageText(this.mergedProps.specialDescription);
    },
    myProductProps() {
      return new ProductProps(this.productProps);
    },
    productPrices() {
      const saleFormats = this.mySaleFormats;
      const prices = saleFormats.map(({ productGuid }) => this.getProductPrice(productGuid));
      let productPricesText = '';
      productPricesText += this.currencyPosition === 'left' ? `${this.currencySymbol} ` : '';
      productPricesText += prices.join(' / ');
      productPricesText += this.currencyPosition === 'right' ? ` ${this.currencySymbol}` : '';
      return productPricesText;
    },
    getProductBlockStyles() {
      return {
        ...this.myBlockProps.getStyles(this.mergedProps.visible),
        ...(this.mergedProps.specialFrame && { 'outline-width': '1px' }),
        ...(this.mergedProps.specialFrame && { 'outline-style': 'solid' }),
        ...(this.mergedProps.isVisible === false && { display: 'none' }),
      };
    },
    getProductTitleStyles() {
      const titleProps = new BlockProps(this.productTitleProps);
      return titleProps.getStyles(this.mergedProps.visible);
    },
    getProductDescriptionStyles() {
      const descriptionProps = new BlockProps(this.productDescriptionProps);
      return descriptionProps.getStyles(this.mergedProps.visible);
    },
    getProductNameStyles() {
      return {
        ...this.myProductProps.commercialNameTextProps.getStyles(),
        ...(this.hasMoreInfo && { cursor: 'pointer' }),
        ...(this.mergedProps.outOfStock && { 'text-decoration': 'line-through' }),
      };
    },
    getProductCameraStyles() {
      return { color: this.myProductProps.commercialNameTextProps.getStyles().color };
    },
    myFeatures() {
      return this.features.map((feature) => new FeaturesItem(feature));
    },
    myTags() {
      return this.tags.map((tag) => new TagsItem(tag));
    },
    hasFeatures() {
      return this.myFeatures.length;
    },
    hasTags() {
      return this.myTags.length;
    },
    featuresVisible() {
      return this.showFeatures;
    },
    productTagVisible() {
      return this.showProductTags;
    },
    featuresIcon() {
      return this.showIconFeatures;
    },
    productTagsIcon() {
      return this.showIconProductTags;
    },
    showFeaturesBlock() {
      return this.hasFeatures && this.featuresVisible;
    },
    showProductTagBlock() {
      return this.hasTags && this.productTagVisible;
    },
    hasMoreInfo() {
      return (this.image && this.image.length > 3)
        || (new MultiLanguageText(this.longCommercialDescription).getText(this.selectedLanguage).length > 0);
    },
    showPopupIcon() {
      return this.popupIcon;
    },
    hasProductRecommendations() {
      return this.productRecommendations.length > 0;
    },
    recommendationText() {
      if (this.hasProductRecommendations) {
        if (this.productRecommendations.length === 1) {
          return new MultiLanguageText(this.productRecommendations[0].text).getText(this.selectedLanguage);
        }
        return new MultiLanguageText(this.productRecommendations[0].underProductText).getText(this.selectedLanguage);
      }
      return '';
    },
    recommendationTextStyles() {
      if (this.hasProductRecommendations) {
        const textProperties = new TextProps(this.productRecommendations[0].underProductTextProperties);
        return { 'text-decoration': 'underline', ...textProperties.getStyles() };
      }
      return {};
    },
  },
};
</script>

<style scoped lang="scss">
.product-block {
  border-radius: .25rem
}

.product-block-shop {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
}

.fas {
  font-size: 12px;
}

.camera {
  cursor: pointer;
}

.product-block-title {
  span, em {
    margin-right: 4px;
  }

  :last-child {
    margin-right: 0;
  }
}

.product-block-description {
  span {
    line-height: 1.15;
  }
}

.prices-to-right {
  margin-left: auto;
  white-space: nowrap;
}

.features {
    padding-top: 1px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }

.features-img {
    width: 20px;
    max-width: 100%;
    height: auto;
    vertical-align: middle;
    padding-right: 2px;
}

</style>
